import config from '../utils/config'
import request from '../utils/request'

const {api} = config;
const { exceptConfig, exceptConfigOne, exceptConfigParams} = api;


export async function findExceptConfig(params) {
    return request({url: exceptConfig, method: 'get', data: params})
}

export async function findExceptConfigParams() {
    return request({url: exceptConfigParams, method: 'get'})
}

export async function saveExceptConfig(params) {
    return request({url: exceptConfig, method: 'post', data: params})
}

export async function deleteExceptConfig(params) {
    return request({url: exceptConfigOne + "??userId="+params.userId, method: 'delete', data: params})
}


// WEBPACK FOOTER //
// ./src/services/exceptConfig.js